import { Checkbox } from '@/components/ui/checkbox';
import { ColumnDef } from '@tanstack/react-table';
import { Translator } from '../translator.type';

export type PartnershipRequest = {
  id: string;
  name: string;
  country: string;
};

export const PARTNERSHIP_REQUEST_COLUMNS = (
  t: Translator,
): ColumnDef<PartnershipRequest>[] => [
  {
    id: 'select',
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && 'indeterminate')
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: 'name',
    header: t('receivers.columns.name'),
  },
  {
    accessorKey: 'country',
    header: t('receivers.columns.country'),
  },
];
